import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import { Link } from "react-router-dom";
import API_BASE_URL from "../apiBase";

export default function BlogClassic() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const slugify = (text = "") =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const getExcerpt = (html, length = 450) => {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || "";
    return text.length > length ? `${text.slice(0, length)}...` : text;
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch(`${API_BASE_URL}/admin/list_blogs.php`);
        const raw = await res.text();
        let data;
        try {
          data = JSON.parse(raw);
        } catch {
          console.error("Invalid blogs response:", raw);
          throw new Error("Received invalid response from server.");
        }

        if (res.ok && data.success) {
          setBlogs(data.blogs || []);
        } else {
          throw new Error(data.error || `Failed to load blogs (${res.status})`);
        }
      } catch (err) {
        setBlogs([]);
        setError(err?.message || "Failed to load blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="blog-classic-page">
      <Header />
      <section
        className="mr_page_page_title page-title"
        style={{
          position: "relative",
          backgroundImage: `url('/aa.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "320px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.45)",
          }}
        ></div>

        <div
          className="auto-container"
          style={{ position: "relative", zIndex: 2 }}
        >
          <div className="content-box">
            <h1
              className="mr_banner_title mr_xpage"
              style={{
                color: "#fff",
                fontSize: "48px",
                fontWeight: "700",
                textShadow: "0 3px 6px rgba(0,0,0,0.6)",
              }}
            >
              Blog
            </h1>
          </div>
        </div>
      </section>

      <div className="mr_page_index">
        <section className="mr_sidebar-page-container p_relative sec-pad">
          <div className="auto-container">
            <div className="row clearfix">
              <div className=" col-lg-4 col-md-12 col-sm-12 sidebar-side order-2">
                <div className="mr_blog-sidebar ml_10">

                  <div
                    id="categories-2"
                    className="mrwidget widget sidebar-widget single-sidebar widget_categories"
                  >
                    <div className="widget-title">
                      <h3>Categories</h3>
                    </div>
                    <ul>
                      <li className="cat-item cat-item-21">
                        <Link to="/solid-waste-management">
                          Solid Waste Management
                        </Link>
                      </li>
                      <li className="cat-item cat-item-21">
                        <Link to="/bio-medical-waste-management">
                          Bio Medical Waste
                        </Link>
                      </li>
                      <li className="cat-item cat-item-21">
                        <Link to="/hazardous-waste-management">
                          Hazardous Waste
                        </Link>
                      </li> <li className="cat-item cat-item-21">
                        <Link to="/faecal-sludge-waste-management">
                          Faecal Sludge
                        </Link>
                      </li> <li className="cat-item cat-item-21">
                        <Link to="/manpower-services-and-staffing">
                          Manpower & Staffing
                        </Link>
                      </li>
                      <li className="cat-item cat-item-21">
                        <Link to="/construction">
                          Construction
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div
                    id="wastix_latest_post_widget-3"
                    className="mrwidget widget sidebar-widget single-sidebar widget_wastix_latest_post_widget"
                  >
                    <div className="post-widget">
                      <div className="widget-title">
                        <h3>Latest Post</h3>
                      </div>{" "}
                      <div className="post-inner">
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="food.jpeg"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="food.jpeg"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  Food Waste Management in 2025

                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  December 4, n2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="sus.jpeg"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="sus.jpeg"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  Why Sustainable Packaging Solutions Are Needed in 2025

                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  December 4, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="in2.jpeg"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="in2.jpeg"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  5 Essential Steps for Industrial Environmental Compliance

                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  December 4, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="im7.jpeg"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="im7.jpeg"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  7 Powerful Industrial Wastewater Treatment Solutions

                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  December 4, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="5 Rainwater Harvesting (2).jpg"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="5 Rainwater Harvesting (2).jpg"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  5 Rainwater Harvesting Conservation Tips

                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  November 28, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="8 Energy-Efficient Appliances.jpg"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="8 Energy-Efficient Appliances.jpg"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  8 Energy-Efficient Appliances for Industrial Use
                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  November 28, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="se.png"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="se.png"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  Climate Risk Assessment For Your Business in 2025
                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  August 25, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  width={850}
                                  height={560}
                                  src="fr.png"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="fr.png"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  Harnessing Drone Technology for Environmental Monitoring in 2025
                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  August 22, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="post">
                          <div className="post-widget">
                            <div className="post-thumbnail">
                              <a href="">
                                <img
                                  loading="lazy"
                                  width={850}
                                  height={560}
                                  src="wl.png"
                                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  srcSet="wl.png"
                                  sizes="(max-width: 850px) 100vw, 850px"
                                />{" "}
                              </a>
                            </div>
                            <div
                              className="post-details"
                              style={{ width: "70%" }}
                            >
                              <h4 className="post-title">
                                <a href="">
                                  7 Critical Environmental Regulations in Service Based Industry
                                </a>
                              </h4>
                              <span className="post-date">
                                <i className="icon-34" />
                                <a href="">
                                  August 6, 2025
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                  // id="tag_cloud-2"
                  // className="mrwidget widget sidebar-widget single-sidebar widget_tag_cloud"
                  >
                    {/* <div className="widget-title">
                    <h3>Tag Cloud</h3>
                  </div>
                  <div className="tagcloud">
                    <a
                      href="https://23july.hostlin.com/wastix/tag/dumpster/"
                      className="tag-cloud-link tag-link-20 tag-link-position-1"
                      style={{ fontSize: "8pt" }}
                      aria-label="Dumpster (9 items)"
                    >
                      Dumpster
                    </a>
                    <a
                      href="https://23july.hostlin.com/wastix/tag/garbage/"
                      className="tag-cloud-link tag-link-22 tag-link-position-2"
                      style={{ fontSize: "8pt" }}
                      aria-label="Garbage (9 items)"
                    >
                      Garbage
                    </a>
                    <a
                      href="https://23july.hostlin.com/wastix/tag/recycling/"
                      className="tag-cloud-link tag-link-23 tag-link-position-3"
                      style={{ fontSize: "8pt" }}
                      aria-label="Recycling (9 items)"
                    >
                      Recycling
                    </a>
                    <a
                      href="https://23july.hostlin.com/wastix/tag/trash/"
                      className="tag-cloud-link tag-link-24 tag-link-position-4"
                      style={{ fontSize: "8pt" }}
                      aria-label="Trash (9 items)"
                    >
                      Trash
                    </a>
                    <a
                      href="https://23july.hostlin.com/wastix/tag/waste/"
                      className="tag-cloud-link tag-link-25 tag-link-position-5"
                      style={{ fontSize: "8pt" }}
                      aria-label="Waste (9 items)"
                    >
                      Waste
                    </a>
                    <a
                      href="https://23july.hostlin.com/wastix/tag/zero-waste/"
                      className="tag-cloud-link tag-link-26 tag-link-position-6"
                      style={{ fontSize: "8pt" }}
                      aria-label="Zero waste (9 items)"
                    >
                      Zero waste
                    </a>
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="content-side col-xs-12 col-sm-12 col-md-12 col-lg-8">
                <div className="mr_blog-standard-content p_relative d_block">
                  {/* Dynamic blogs from admin panel */}
                  {loading && (
                    <p style={{ marginBottom: "20px" }}>Loading latest blogs...</p>
                  )}
                  {error && (
                    <p style={{ color: "red", marginBottom: "20px" }}>
                      {error}
                    </p>
                  )}
                  {!loading && !error && blogs.length === 0 && (
                    <p style={{ marginBottom: "20px" }}>
                      No blogs published yet.
                    </p>
                  )}
                  {blogs &&
                    blogs.length > 0 &&
                    blogs.map((blog) => (
                      <div
                        key={blog.id}
                        className="post-dynamic post type-post status-publish format-standard has-post-thumbnail hentry"
                      >
                        <div className="mr_news-block-one mb_40">
                          <div className="mr_inner-box">
                            {blog.image_url && (
                              <div className="mr_image-box p_relative d_block">
                                <figure className="mr_image p_relative d_block b_radius_5">
                                  <a href="#">
                                    <img
                                      src={blog.image_url}
                                      alt={blog.title}
                                      className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                      style={{ width: "100%", height: "auto" }}
                                    />
                                  </a>
                                </figure>
                              </div>
                            )}
                            <div className="mr_lower-content">
                              <h2 className="mr_blog_post_title">
                                <span>{blog.title}</span>
                              </h2>
                              <ul className="mr_post-info">
                                <li className="mr_blog_post_meta">
                                  <span>Admin</span>
                                </li>
                                {blog.created_at && (
                                  <li className="mr_blog_post_meta">
                                    <span>
                                      {new Date(blog.created_at).toLocaleDateString(
                                        "en-IN",
                                        {
                                          year: "numeric",
                                          month: "long",
                                          day: "numeric",
                                        }
                                      )}
                                    </span>
                                  </li>
                                )}
                              </ul>
                              <div className="text mr_blog_post_text">
                                <p>{getExcerpt(blog.description)}</p>
                              </div>
                              <div className="mr_btn-box" style={{ marginTop: "12px" }}>
                                <Link
                                  to={`/blog/${blog.id}-${slugify(blog.title)}`}
                                  className="mr_theme-btn mr_theme-btn-six"
                                >
                                  Read More <i className="icon-4" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src=""
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt="food.jpeg"
                                decoding="async"
                                srcSet="food.jpeg"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <Link to="/food">
                              Food Waste Management in 2025{" "}

                            </Link>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                December 4, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              Food waste management is marked by significant advances in technology, regulation, and sustainability practices. It’s main goal is to reduce environmental impact and create circular economies. Through cutting-edge methods such as anaerobic digestion, composting, and AI-powered waste tracking that help convert food waste into valuable resources like biofuels and fertilizers. Strong regulatory measures and corporate sustainability goals are accelerating the adoption of these innovative solutions......
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <Link
                              to="/food"
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src=""
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt="sus.jpeg"
                                decoding="async"
                                srcSet="sus.jpeg"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <Link to="/packaging">
                              Why Sustainable Packaging Solutions Are Needed in 2025{" "}

                            </Link>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                December 4, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              The sustainable packaging market grows from USD 292.71 billion in 2024 to USD 423.56 billion by 2029 at 7.67% CAGR. Plastic pollution hits oceans with 8 million metric tons yearly, demanding urgent shifts. Over 40% of companies adopt innovative techniques by 2025 for circular economies. Consumers, especially Millennials and Gen Z, favor eco-friendly options amid rising regulations. Green Circle Environment pushes these changes to cut waste and emissions effectively.....
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <Link
                              to="/packaging"
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src=""
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt="in2.jpeg"
                                decoding="async"
                                srcSet="in2.jpeg"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <Link to="/environmental">
                              5 Essential Steps for Industrial Environmental Compliance{" "}

                            </Link>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                December 4, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              Environmental compliance is crucial for sustainable and responsible industrial operations in 2025. With evolving regulations and increasing environmental awareness, industries must adopt proactive measures to meet legal requirements, reduce their ecological footprint, and promote safe practices. This blog highlights five essential steps that industries can take to ensure robust environmental compliance while supporting sustainability goals......
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <Link
                              to="/environmental"
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src="im7.jpeg"
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt=""
                                decoding="async"
                                srcSet="im7.jpeg"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <Link to="/industrial">
                              7 Powerful Industrial Wastewater Treatment Solutions{" "}

                            </Link>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                December 4, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              Industrial wastewater treatment is critical for sustainable industrial operations and environmental protection in 2025. Industrial processes generate contaminated water laden with chemicals, heavy metals, and organic pollutants that demand advanced treatment solutions. This blog explores seven powerful and innovative wastewater treatment technologies shaping the industrial sector this year, helping industries meet stringent regulations while promoting water reuse and conservation.
                              .....
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <Link
                              to="/industrial"
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src="5 Rainwater Harvesting (2).jpg"
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt=""
                                decoding="async"
                                srcSet="5 Rainwater Harvesting (2).jpg"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <Link to="/rain">
                              5 Rainwater Harvesting Conservation Tips{" "}

                            </Link>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                November 28, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              Rainwater harvesting is a vital method to conserve water sustainably. With increasing water scarcity worldwide, capturing and using rainwater reduces reliance on conventional sources. Green Circle Environment advocates simple yet effective approaches to optimize rainwater harvesting. Whether you live in an urban or rural area, following these five tips will help you conserve water efficiently, reduce utility costs, and support environmental balance.....
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <Link
                              to="/rain"
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src="8 Energy-Efficient Appliances.jpg"
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt=""
                                decoding="async"
                                srcSet="8 Energy-Efficient Appliances.jpg"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <Link to="/energy">
                              8 Energy-Efficient Appliances for Industrial Use{" "}
                            </Link>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                November 28, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              The rising energy costs and environmental concerns demand smarter solutions. Industrial energy efficiency reduces operational expenses while cutting carbon emissions and improving sustainability. According to recent studies, nearly 45% of global electricity powers industrial motors alone, highlighting vast untapped potential for efficiency improvements. Technologies like high-efficiency motors, variable frequency drives (VFDs), and smart automation are transforming industries by saving up to 40% energy in key processes. These advancements not only strengthen energy security but also boost competitiveness. Green Circle Environment champions the adoption of these appliances to help industries reduce their carbon footprint and ensure long-term economic benefits.
                              ....
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <Link
                              to="/energy"
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1930 post type-post status-publish format-standard has-post-thumbnail hentry category-garbage-pickup tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src="se.png"
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt=""
                                decoding="async"
                                srcSet="se.png"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <a href="">
                              Climate Risk Assessment For Your Business in 2025{" "}
                            </a>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                August 25, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">2 Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              Climate change is redefining numerous business working models across the world, and in India, the stakes are particularly high. From frequent heat waves and unpredictable monsoons to urban flooding and water scarcity, climate-related risks are no longer abstract projections; they’re weekly headlines. For businesses, these challenges pose dual threats: physical risks that disrupt operations and regulatory risks that drive compliance costs and reshape industry norms....
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <a
                              href=""
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1929 post type-post status-publish format-standard has-post-thumbnail hentry category-dumpster-rental tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src="fr.png"
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt=""
                                decoding="async"
                                srcSet="fr.png"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <a href="">
                              Harnessing Drone Technology for Environmental Monitoring in 2025{" "}
                            </a>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                August 22, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">No Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>
                              Drone-powered monitoring combines aerial capability with advanced sensors and remote sensing technologies to capture environmental data unseen by the naked eye. From capturing detailed vegetation cover to detecting chemical pollutants, drones are bridging the gap between manual limitations and data-driven insights. Here are 7 ways how drones are transforming environmental changes: […]
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <a
                              href=""
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post-1928 post type-post status-publish format-standard has-post-thumbnail hentry category-waste-collection tag-dumpster tag-garbage tag-recycling tag-trash tag-waste tag-zero-waste">
                    <div className="mr_news-block-one mb_40">
                      <div className="mr_inner-box">
                        <div className="mr_image-box p_relative d_block">
                          <figure className="mr_image p_relative d_block b_radius_5">
                            <a href="">
                              <img
                                width={850}
                                height={560}
                                src="wl.png"
                                className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                alt=""
                                decoding="async"
                                srcSet="wl.png"
                                sizes="(max-width: 850px) 100vw, 850px"
                              />{" "}
                            </a>
                          </figure>
                        </div>
                        <div className="mr_lower-content">
                          <h2 className="mr_blog_post_title">
                            <a href="">
                              Waste management container or bin for my home?{" "}
                            </a>
                          </h2>
                          <ul className="mr_post-info">
                            <li className="mr_blog_post_meta">
                              <a href="">
                                admin{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">
                              <a href="">
                                August 6, 2025{" "}
                              </a>
                            </li>
                            <li className="mr_blog_post_meta">No Comments </li>
                          </ul>
                          <div className="text mr_blog_post_text">
                            <p>

                              Service companies must control emissions and ensure indoor air quality. Proper ventilation systems limit pollutants such as volatile organic compounds (VOCs) from cleaning agents. Regular maintenance of HVAC systems and use of eco-certified products help minimize harmful air emissions, protecting workers, clients, and the immediate environment. Compliance also reduces respiratory risks and aligns your business with environmental health standards.... […]
                            </p>
                          </div>
                          <div className="mr_btn-box">
                            <a
                              href=""
                              className="mr_theme-btn mr_theme-btn-six"
                            >
                              Read More <i className="icon-4" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="mr_pagination-wrapper">
                <ul className="pagination mr_pagination">
                  <li>
                    <span
                      aria-label="Page 1"
                      aria-current="page"
                      className="page-numbers current"
                    >
                      1
                    </span>
                  </li>
                  <li>
                    <a
                      aria-label="Page 2"
                      className="page-numbers"
                      href="https://23july.hostlin.com/wastix/blog-classic/page/2/"
                    >
                      2
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="Page 3"
                      className="page-numbers"
                      href="https://23july.hostlin.com/wastix/blog-classic/page/3/"
                    >
                      3
                    </a>
                  </li>
                  <li>
                    <a
                      className="next page-numbers"
                      href="https://23july.hostlin.com/wastix/blog-classic/page/2/"
                    >
                      <i className="fas fa-angle-right" />
                    </a>
                  </li>
                </ul>
              </div> */}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
}
